// Modelo de cobrança das UCs do termo (#6367, pedido do Felipe Braz, 21/10/2026). Antes, toda UC
// nova nascia no modelo separado e só passava ao boleto único depois que o cliente aceitava no
// Portal — a primeira cobrança saía no formato errado.
//
// 03/11/2026 (Vinícius): de agora em diante todo cliente novo é boleto único. Saiu do termo a
// escolha "Boleto Equatorial + Boleto Vigor" e a caixa "a assinatura vale como aceite": toda UC
// da Vigor vai como 'unificado' e a assinatura sempre vale como aceite. 'separado' continua
// válido no banco para as UCs gravadas antes.
//
// A escolha não liga o boleto único direto: o gatilho do banco transforma a assinatura num aceite
// de canal 'termo', e a liberação de sempre (liberar_boleto_unico_apos_aceite) segura quem tem
// débito automático na Equatorial até o cancelamento — senão o cliente pagaria a conta de luz
// duas vezes.

export type ModeloCobranca = 'unificado' | 'separado';

export interface UcModeloCobranca {
  id: number;
  empresa_parceira_id?: string | number | null;
}

/** UC de empresa parceira já nasce no boleto único (trigger da parceira): fica fora do aceite pelo termo. */
export const ucDaVigor = (uc: UcModeloCobranca) => !uc.empresa_parceira_id;

/** Modelo de cobrança gravado em cada UC da Vigor do termo: sempre boleto unificado. */
export function modelosDoTermo(ucs: UcModeloCobranca[]): Record<number, ModeloCobranca> {
  const modelos: Record<number, ModeloCobranca> = {};
  for (const uc of ucs) if (ucDaVigor(uc)) modelos[uc.id] = 'unificado';
  return modelos;
}
